{
  "general": {
    "ok": "OK",
    "yes": "Taip",
    "no": "Ne",
    "cancel": "Atšaukti",
    "close": "Uždaryti",
    "delete": "Ištrinti",
    "remove": "Pašalinti",
    "save": "Išsaugoti",
    "edit": "Redaguoti",
    "view": "Žiūrėti",
    "add": "Pridėti",
    "selectAll": "Žymėti viską",
    "dateAdded": "Pridėjimo data",
    "dateUpdated": "Atnaujinimo data",
    "loading": "Kraunasi...",
    "noData": "Nėra duomenų",
    "back": "Atgal",
    "accessDenied": "Prieiga uždrausta",
    "name": "Vardas",
    "startDate": "Pradžios data",
    "endDate": "Pabaigos data",
    "open": "Atidaryti",
    "action": "Veiksmas",
    "categories": "Kategorijos",
    "manage": "VALDYTI",
    "saved": "Išsaugota",
    "updated": "Atnaujinta",
    "deleted": "Panaikinta",
    "dragNDropFile": "Nuvilkite failą čia arba:",
    "browse": "Naršyti",
    "every": "Kiekvieną",
    "onceEvery": "Kartą per",
    "created": "Sukurta",
    "search": "Paieškos",
    "chooseADate": "Pasirinkite datą",
    "average": "Vidutiniškai",
    "selectQuestion": "Pasirinkite klausimą",
    "all": "Visi",
    "active": "Aktyvus",
    "inactive": "Neaktyvus",
    "enabled": "Įjungta",
    "disabled": "Išjungta",
    "rows": "eilutės",
    "export": "Eksportuoti",
    "startTime": "Pradžios laikas",
    "endTime": "Pabaigos laikas",
    "exportLocationHistory": "Eksportuoti vietos istoriją",
    "exportStopHistory": "Eksportuoti sustojimų istoriją",
    "exportDateRangeTooLong": "Datos diapazonas negali viršyti {days} dienų",
    "settings": "Nustatymai",
    "signOut": "Pasirašyti",
    "clickToSort": "Spustelėkite norėdami rūšiuoti",
    "duration": "Trukmė",
    "visitStart": "Apsilankymo pradžia",
    "visitEnd": "Apsilankymo pabaiga",
    "selectGender": "Pasirinkti lytį",
    "gender": {
      "male": "Vyras",
      "female": "Moteris"
    }
  },
  "time": {
    "timePresets": "Laiko išankstiniai nustatymai",
    "today": "Šiandien",
    "yesterday": "Vakar",
    "pastNDays": "Praėjusios {n} dienos",
    "pastYear": "Praėję metai",
    "allTime": "Visas laikas",
    "clearSelection": "Išvalyti pasirinkimą",
    "jumpToToday": "Pereiti prie Šiandien",
    "previousWeek": "praėjusią savaitę",
    "previousMonth": "ankstesnis mėnuo"
  },
  "charts": {
    "nMostFrequentlyProcedures": "{n} dažniausiai pradedamos procedūros",
    "nLeastFrequentlyProcedures": "{n} rečiausiai pradedamos procedūros",
    "oftenAssistedProcedures": "Dažnai padedamos procedūros",
    "nursesExperience": "Slaugytojų patirtis",
    "nursesGender": "Slaugytojų lytis",
    "nursesAge": "Slaugytojų amžius",
    "workIntensityChart": "Darbo intensyvumo diagrama",
    "surveyChart": "Apklausos diagrama",
    "nurses": "Slaugytojai",
    "Averageshiftduration": "Vidutinė pamainos trukmė",
    "Averageshiftintensity": "Vidutinis pamainos intensyvumas",
    "Averagenrofpatients": "Vidutinis pacientų skaičius",
    "Averageacuitypershift": "Vidutinis pamainos aštrumas",
    "lessThenYear": "Mažiau nei 1 metai",
    "yearToFiveYears": "1-5 metai",
    "fiveToTenYears": "5-10 metų",
    "moreThanTenYears": "Daugiau nei 10 metų",
    "maleNurses": "Slaugytojai vyrai",
    "femaleNurses": "Slaugytojos moterys",
    "tiredness chart": "Nuovargio diagrama",
    "tiredness score": "Nuovargio balas",
    "intensity score": "Intensyvumo balas",
    "work intensity chart": "Darbo intensyvumo diagrama",
    "selectStudy": "Pasirinktas tyrimas",
    "count": "Skaičiuokite",
    "tiredness": "Nuovargis",
    "intensity": "Intensyvumas"
  },
  "form": {
    "thisFieldIsRequired": "Šis laukas yra būtinas",
    "canNotStartBeforeParentStarts": "Negalima pradėti, nepradėjus tėvams",
    "canNotStartWhenParentEnded": "Negalima pradėti, kai baigė tėvai",
    "canNotEndBeforeParentStarts": "Negalima baigti, kol tėvai nepradėjo",
    "canNotEndWhenParentEnded": "Negalima baigti, kai baigė tėvai",
    "canNotEndBeforeStart": "Negalima baigti prieš pradedant",
    "canNotStartAfterEnd": "Negalima pradėti pabaigus",
    "insertNumber": "Įrašyti numerį",
    "days": "Diena (-os)",
    "weeks": "Savaitė (-ės)",
    "months": "Mėnuo (-iai)",
    "years": "Metai (-iai)"
  },
  "menu": {
    "home": "Pagrindinis",
    "departments": "Skyriai",
    "institutions": "Institucijos",
    "users": "Vartotojai",
    "scheduling": "Planavimas",
    "procedures": "Procedūros",
    "study": "Tikrinti",
    "survey": "Apklausa",
    "procedure": "Procedūra",
    "reinviteusers": "Pakartotinis naudotojų pakvietimas",
    "userGuide": "Vartotojo vadovas",
    "devices": "Įrenginiai",
    "groups": "Grupės",
    "learningobject": "Mokymosi pasirinkimai",
    "manageStudies": "Valdyti studijas",
    "statistics": "Statistika",
    "reports": "Ataskaitos",
    "deviceGroups": "Įrenginių grupės",
    "patients": "Pacientai",
    "nurseLocation": "Slaugytojo vieta",
    "usersList": "Naudotojų sąrašas",
    "visitForms": "Apsilankymo formos"
  },
  "procedures": {
    "procedures": "Procedūros",
    "searchProcedures": "Ieškoti procedūros",
    "addProcedure": "Pridėti procedūrą",
    "deleteProcedure": "Pašalinti procedūrą",
    "filter": "Filtras",
    "sort": "Rūšiuoti",
    "public": "Viešoji svetainė",
    "private": "Privatus",
    "department": "Skyrius",
    "category": "Kategorija",
    "publicPrivate": "Viešasis / privatusis",
    "importProcedures": "Importuoti procedūras ",
    "addAndSchedule": "Įrenginių grupių procedūrų įtraukimas ir planavimas",
    "addAnother": "Kitos procedūros įtraukimas",
    "selectType": "Pasirinkite tipą",
    "saveProcedure": "Išsaugoti procedūrą",
    "noFrequency": "Dažnis nepridedamas"
  },
  "procedure": {
    "name": "Vardas",
    "disableProcedure": "Išjungti procedūrą",
    "type": "Tipas",
    "revisionHistory": "Pataisymų istorija",
    "addProceduresInformation": "Procedūros informacijos pridėjimas",
    "editProceduresInformation": "Procedūros informacijos redagavimas",
    "duplicateStartEndStepWarning": "Leidžiamas tik 1 pradžios ir 1 pabaigos žingsnis",
    "procedureNotFound": "Procedūra nerasta",
    "category": "Kategorija",
    "authors": "Autorius",
    "owner": "Savininkas",
    "languagesAvailable": "Galimos kalbos",
    "publicPrivate": "Viešasis / privatusis",
    "defineFeedback": "Atsiliepimų apibrėžimas",
    "seeFeedback": "Peržiūrėkite atsiliepimus",
    "statistics": "Statistika",
    "description": "Aprašymas",
    "information": "Informacija",
    "step": "Žingsnis",
    "media": "Failai",
    "allSteps": "Visi žingsniai",
    "createNewStep": "Įtraukti veiksmą",
    "viewAs": "Žiūrėti kaip",
    "searchSteps": "Paieškos žingsniai",
    "procedureName": "Procedūros pavadinimas",
    "procedureCategory": "Procedūros kategorija",
    "language": "Kalba",
    "procedureLanguage": "Procedūros kalba",
    "public": "Viešoji svetainė",
    "unableToLoad": "Nepavyko įkelti procedūros",
    "department": "Skyrius",
    "addNewCategory": "Pridėti naują kategoriją",
    "institution": "Įstaiga",
    "import": "Ikelti",
    "stepNr": "Nr",
    "deleteStep": "Patvirtinkite, kad ištrintumėte veiksmą",
    "lastUpdated": "Paskutinį kartą atnaujinta",
    "startTime": "Procedūros pradžios laikas",
    "endTime": "Procedūros pabaigos laikas"
  },
  "reports": {
    "reports": "Ataskaitos",
    "chooseADate": "Pasirinkite datą",
    "userID": "Vartotojo ID",
    "deviceGroup": "Įrenginių grupė",
    "allReports": "Visos ataskaitos",
    "failedAudits": "Nepavykę auditai",
    "reportDate": "Ataskaitos data",
    "all": "Visi",
    "successfull": "Sėkmingai",
    "failed": "Nepavyko",
    "finished": "Baigtas",
    "stopped": "Sustabdytas",
    "started": "Pradėta",
    "deviceStatistics": "Įrenginio statistika",
    "devicesInUse": "Naudojami prietaisai",
    "deviceAudits": "Įrenginių auditai",
    "auditComingSoon": "Auditas jau greitai",
    "auditNotDone": "Auditas neatliktas",
    "auditDone": "Atliktas auditas",
    "averageTimeSpentOnProcedure": "Vidutinis laikas, praleistas procedūrai",
    "selectProcedure": "Pasirinkite procedūrą",
    "noGroupSelected": "Nepasirinkta jokia grupė",
    "rateFailedAudits": "Auditų metu nepavyko atlikti įrenginių",
    "proceduresHistory": "Procedūrų istorija",
    "procedureStatus": "Procedūros statusas",
    "noProcedureHistory": "Nėra procedūrų istorijos"
  },
  "devices": {
    "group": "Grupė",
    "devices": "Įrenginiai",
    "searchDevices": "Ieškoti įrenginių",
    "addDevice": "Pridėti įrenginį",
    "addDevices": "Įrenginių įtraukimas",
    "addAnotherDevice": "Pridėti kitą įrenginį",
    "deleteDevice": "Naikinti įrenginį",
    "filter": "Filtras",
    "sort": "Rūšiuoti",
    "public": "Viešoji svetainė",
    "private": "Privatus",
    "department": "Skyrius",
    "category": "Kategorija",
    "publicPrivate": "Viešasis / privatusis",
    "importDevices": "Įrenginių importavimas",
    "allDevices": "Visi įrenginiai"
  },
  "device": {
    "device": "Prietaisas",
    "name": "Vardas",
    "disableDevice": "Išjungti įrenginį",
    "revisionHistory": "Pataisymų istorija",
    "editDevicesInformation": "Įrenginio informacijos redagavimas",
    "deviceNotFound": "Įrenginys nerastas",
    "category": "Kategorija",
    "authors": "Autorius",
    "owner": "Savininkas",
    "languagesAvailable": "Galimos kalbos",
    "publicPrivate": "Viešasis / privatusis",
    "defineFeedback": "Apibrėžti atsiliepimą",
    "seeFeedback": "Peržiūrėkite atsiliepimus",
    "statistics": "Statistika",
    "description": "Aprašymas",
    "information": "Informacija",
    "media": "Failai",
    "viewAs": "Žiūrėti kaip",
    "deviceName": "Įrenginio pavadinimas",
    "deviceCategory": "Įrenginio kategorija",
    "language": "Kalba",
    "deviceLanguage": "Įrenginio kalba",
    "public": "Viešoji svetainė",
    "unableToLoad": "Nepavyksta įkelti įrenginio",
    "department": "Departamentas",
    "group": "Grupė",
    "addNewCategory": "PRIDĖTI NAUJĄ KATEGORIJĄ",
    "institution": "Įstaiga",
    "import": "Importuoti",
    "model": "Įrenginio modelis",
    "lifeCycleNum": "Gyvavimo ciklo numeris",
    "lifeCycleTime": "Gyvavimo ciklo laikas",
    "lifeCycle": "Gyvavimo ciklas",
    "udiQrCodef": "QR kodo UDI",
    "uuid": "UUID",
    "orUploadPicture": "arba įkelti QR kodo nuotrauką",
    "dropFile": "Nuvilkite failą čia arba:",
    "lastUpdated": "Paskutinį kartą atnaujinta",
    "viewStatistics": "Peržiūrėti statistiką",
    "auditFrequency": "Audito dažnumas",
    "auditProcedure": "Audito procedūra",
    "lifeCycleStart": "Gyvavimo ciklo pradžia",
    "lifeCycleEnd": "Gyvavimo ciklo pabaiga",
    "deviceProcedureHistory": "Įrenginio procedūrų istorija",
    "comments": "Komentarai",
    "commented": "Komentarų",
    "groupName": "Grupės pavadinimas",
    "audit": "Auditas",
    "other": "Kita",
    "udiAlreadyExists": "šis UDI jau egzistuoja",
    "status": "Būsena"
  },
  "step": {
    "transitionToNextStep": "Perėjimas prie kito veiksmo",
    "transitionType": "Pereinamojo laikotarpio tipas",
    "parentStep": "Tėvų žingsnis",
    "previousStep": "Ankstesnis veiksmas",
    "option": "Parinktis",
    "editStep": "Redaguoti veiksmą",
    "description": "Aprašymas",
    "addNewStep": "Pridėti naują žingsnį",
    "owner": "Savininkas",
    "viewInProcedure": "Žiūrėti procedūroje",
    "stepMedia": "Žingsnių laikmena",
    "saveMedia": "Išsaugoti",
    "dropFilesOrClickToUpload": "Tempkite failus čia arba spustelėkite, kad įkeltumėte",
    "addDescription": "Pridėti aprašymą",
    "chooseType": "Pasirinkti tipą",
    "insertOption": "Įterpti pasirinkima",
    "insertMinValue": "Įterpti MIN reikšmę",
    "insertMaxValue": "Įterpti MAX reikšmę",
    "chooseTransitionType": "Pasirinkite perėjimo tipą",
    "chooseParentSep": "Pasirinkite tėvų žingsnį",
    "chooseStepOption": "Pasirinkite žingsnio parinktį",
    "addParentStep": "Pirminio veiksmo įtraukimas",
    "type": "Tipas",
    "value": "Vertė",
    "error": {
      "WONT_REACH_END": "Nėra kelio į PABAIGĄ",
      "EXIT_NOT_IN_USE": "Nepanaudotas išėjimas",
      "NO_PARENT_SET": "Neturi ankstesnio žingsnio",
      "PARENT_NOT_EXITS": "Apibrėžtas tėvas neišeina",
      "DUPLICATE_START": "Procedūra gali turėti tik vieną PRADŽIOS žingsnį",
      "DUPLICATE_END": "Procedūra gali turėti tik vieną PABAIGOS žingsnį"
    }
  },
  "department": {
    "institution": "Įstaigos pavadinimas",
    "createNewDepartment": "Pridėti skyrių",
    "searchDepartments": "Ieškoti skyrių",
    "departmentName": "Skyriaus pavadinimas",
    "institutionName": "Įstaigos pavadinimas",
    "departmentAdmin": "Skyriaus administratorius",
    "thisFieldIsRequired": "Šis laukas yra būtinas",
    "addDepartment": "Pridėti skyrių",
    "edit": "Redaguoti",
    "updatedDepartment": "Atnaujinti skyrių",
    "createdNewDepartment": "Sukurtas naujas skyrius"
  },
  "user": {
    "inviteUsers": "Pakviesti vartotojus",
    "reInviteUsers": "Pakviesti vartotojus išnaujo ",
    "searchUsers": "Ieškoti naudotojo (-ų)",
    "user": "Vartotojas",
    "institutionAndDepartment": "Įstaiga ir skyrius",
    "subscription": "Prenumerata",
    "chooseUserRole": "Pasirinkite vartotojo vaidmenį",
    "userRole": "Vartotojo vaidmuo",
    "emails": "Vartotojo el. pašto adresas (-ai)",
    "department": "Skyrius",
    "departmentAdmin": "Departamento administratorius",
    "emailsDescription": "Įveskite 1 ar daugiau el. paštų, atskirtų kabliataškiu. Kvietimai registruotis bus išsiųsti naudotojams el. paštu.",
    "thisFieldIsRequired": "Šis laukas yra būtinas",
    "nurse": "Slaugytoja",
    "patient": "Pacientas",
    "contentEditor": "Turinio redaktorius",
    "projectAdmin": "Projekto administratorius",
    "familyMember": "Šeimos narys",
    "institutionalAdmin": "Institucinis administratorius",
    "institution": "Įstaiga",
    "filter": "Filtras",
    "sort": "Rūšiuoti",
    "accountSettings": "Paskyros nustatymai",
    "logOut": "Atsijungti",
    "contactInformation": "Kontaktinė informacija",
    "dateOfBirth": "Gimimo data",
    "gender": "Lytis",
    "contact": "Kontaktai",
    "password": "Slaptažodį",
    "userInformation": "Vartotojo informacija",
    "resetPassword": "Slaptažodžio nustatymas iš naujo",
    "sendResetPasswordEmailTo": "Siųsti slaptažodžio nustatymo iš naujo el. laišką adresu",
    "resetRequestSentTo": "Slaptažodžio patvirtinimo el. laiškas, išsiųstas adresu",
    "userDetailsUpdated": "Atnaujinta vartotojo informacija",
    "noUsersSelected": "Nepasirinkta vartotojų",
    "invite": "Pakviesti",
    "grantRole": "Suteikti vaidmenį",
    "revokeRole": "Atšaukti vaidmenį",
    "confirms": {
      "revokeRoleTitle": "Atšaukti vaidmenį",
      "revokeRoleText": "Ar tikrai norite atšaukti šio vartotojo vaidmenį?",
      "revokeRoleSuccess": "Vaidmuo atšauktas",
      "revokeRoleFailed": "Nepavyko atšaukti vaidmens",
      "revokeRoleNoRole": "Šiam vartotojui nerastas vaidmens priskyrimas"
    },
    "homeNurse": "Namų slaugytoja"
  },
  "institution": {
    "name": "Vardas",
    "region": "Regionas",
    "contact": "Kontaktas",
    "searchInstitutions": "Paieškos institucija (-os)",
    "createNewInstitution": "Pridėti instituciją",
    "switch": "Perjungti",
    "unableToSwitch": "Nepavyksta perjungti",
    "switchedTo": "Įstaigos perėjo prie",
    "street": "Gatvė",
    "institutionStreet": "Gatvė",
    "institutionHouse": "Namas",
    "institutionCity": "Miestas",
    "institutionCounty": "Rajonas",
    "institutionCountry": "Šalis",
    "institutionTimezone": "Laiko juosta",
    "institutionLanguage": "Kalba",
    "stopDetectionDuration": "Sustojimo aptikimo trukmė (minutės)",
    "createdNewInstitution": "Sukūrė naują instituciją",
    "updatedInstitution": "Atnaujinta institucija",
    "edit": "Redaguoti"
  },
  "datatable": {
    "rowsPerPage": "Eilutės puslapyje"
  },
  "study": {
    "name": "Vardas",
    "studyName": "Tyrimo pavadinimas",
    "status": "Būsena",
    "department": "Skyrius",
    "author": "Autorius",
    "owner": "Savininkas",
    "duration": "Trukmė",
    "startDate": "Pradžios data",
    "endDate": "Pabaigos data",
    "searchStudy": "Paieškos studijos",
    "addStudy": "Pridėti tyrimą",
    "description": "Aprašymas",
    "visibility": "Matomumas",
    "permission": {
      "department": "Skyrius",
      "institution": "Įstaiga",
      "public": "Viešoji svetainė"
    },
    "createdNewStudy": "Sukūrė naują tyrimą",
    "updatedStudy": "Atnaujintas tyrimas",
    "deleteStudy": "Ištrinti tyrimą",
    "editStudy": "Redaguoti tyrimą",
    "deletedStudy": "Išbrauktas tyrimas"
  },
  "studyResults": {
    "user": "Vartotojas",
    "department": "Skyrius",
    "study": "Mokymasis",
    "date": "Data",
    "survey": "Apklausa",
    "results": "Rezultatai",
    "studyResults": "Tyrimo rezultatai",
    "surveyResults": "Apklausos rezultatai",
    "list": "Sąrašus",
    "graph": "Grafikas",
    "surveyStartDate": "Apklausos pradžia",
    "surveyEndDate": "Apklausa",
    "userResults": "Vartotojo rezultatai",
    "question": "Klausimas",
    "questionType": "Klausimo tipas",
    "answer": "Atsakymas",
    "position": "Poziciją"
  },
  "survey": {
    "key": "Raktas",
    "name": "Vardas",
    "allAssessmentPeriods": "Visi vertinimo laikotarpiai",
    "createNewPeriod": "Sukurkite naują laikotarpį",
    "createNewSurvey": "Naujos apklausos kūrimas",
    "addAssessmentPeriod": "Sukurti naują laikotarpio dalį",
    "addSurveyPeriod": "Sukurti naują apklausos laikotarpį",
    "periodName": "Vardas",
    "completePreviousPeriods": "Ar tyrimo dalyvis turi praeiti ankstesnį (-ius) laikotarpį (-ius), kad šis laikotarpis būtų tinkamas?",
    "startDate": "Pradžios data",
    "endDate": "Pabaigos data",
    "author": "Autorius",
    "duration": "Trukmė",
    "type": "Tipas",
    "SURVEY_PERIOD": "TIRIAMASIS LAIKOTARPIS",
    "NONE": "Nėra",
    "ASSESSMENT_PERIOD": "VERTINIMO LAIKOTARPIS",
    "addPeriod": "Pridėti naują laikotarpį",
    "questionList": "Klausimus",
    "added": "Sukurta nauja apklausa",
    "createNewQuestion": "Pridėti klausimą",
    "addNew": "Pridėti naują",
    "period": "Laikotarpį",
    "question": "Klausimas",
    "position": "Poziciją",
    "surveyHasOverallScore": "Ar apklausa turi bendrą balą?",
    "howScoreCalculated": "Kaip apskaičiuojamas bendras balas?",
    "surveyHasCategoryScore": "Ar apklausa turi konkrečios kategorijos balą?",
    "sumAnswers": "Visų atsakymų suma",
    "avgAnswers": "Visų atsakymų vidurkis",
    "basicInformation": "Pagrindinė informacija",
    "surveyScore": "Apklausos balas",
    "addAnotherCategory": "Kitos kategorijos įtraukimas",
    "selectOption": "Pasirinkite parinktį",
    "selectSurvey": "Pasirinkite apklausą",
    "jobEngagement": "Įsitraukimas į darbą",
    "burnoutScores": "Perdegimo balai",
    "viewScores": "PERŽIŪRĖTI BALUS",
    "hasOverallScore": "Apklausa turi bendrą balą",
    "hasNoOverallScore": "Apklausa neturi bendro balo",
    "noChartData": "Nėra diagramos duomenų",
    "selectChartType": "Pasirinkite diagramos tipą",
    "surveyCategoryInfo": "Apklausoje yra kategorijų, skirtų klausimams organizuoti. Šiame skyriuje turite galimybę juos keisti ir prižiūrėti."
  },
  "question": {
    "name": "Vardas",
    "type": "Tipas",
    "questionType": "Klausimo tipas",
    "position": "Poziciją",
    "details": "Informacijos",
    "question": "Klausimas",
    "answers": "Atsakymai",
    "set": "Rinkinys",
    "text": "Tekstas",
    "options": "Parinktys",
    "value": "Vertė",
    "meaning": "Prasme",
    "category": "Kategorija",
    "types": {
      "CHOICE": "Pasirinkimas",
      "SCALE": "Skalė",
      "COGNITION": "Pažinimo",
      "FREE_TEXT": "Laisvas tekstas",
      "MULTI_CHOICE": "Žymės langelis",
      "MEDIA": "Failai"
    },
    "added": "Sukūrė naują klausimą",
    "updated": "Klausimas atnaujintas",
    "cognitionName": "Pažinimo pavadinimas",
    "cognitionType": "Pažinimo tipas",
    "editQuestion": "Redaguoti klausimą",
    "deleteQuestion": "Ištrinti klausimą"
  },
  "category": {
    "category": "Kategorija",
    "name": "Vardas",
    "description": "Aprašymas",
    "shortDescription": "Trumpas aprašymas",
    "createdNewCategory": "Sukurta nauja kategorija",
    "manageCategories": "Kategorijų valdymas",
    "deleteCategory": "Naikinti kategoriją",
    "createAnother": "Kitos kategorijos kūrimas",
    "deleteAlert": "Šios kategorijos ištrynimas yra negrįžtamas. Perkelkite klausimus į esamą kategoriją arba palikite juos nesurūšiuotus.",
    "deleteMoveTarget": "Kur turėtų eiti šios kategorijos klausimai?",
    "noCategory": "Nėra kategorijos"
  },
  "groups": {
    "createNewGroup": "Pridėti grupę",
    "searchGroups": "Ieškoti grupių (-ės)",
    "addGroup": "Pridėti grupę",
    "newGroup": "Nauja grupė",
    "groupName": "Grupės pavadinimas",
    "lifeCycleEndingSoon": "Gyvavimo ciklas netrukus baigsis",
    "lifeCycleEnded": "Baigėsi gyvenimo ciklas",
    "happyDevices": "Laimingi įrenginiai",
    "searchDeviceGroups": "Paieškos įrenginių grupės",
    "backToGroups": "Grįžti į įrenginių grupes",
    "saveGroup": "Įrašyti grupę"
  },
  "group": {
    "name": "Vardas",
    "description": "Aprašymas",
    "createdNewGroup": "Sukurta nauja grupė",
    "updatedGroup": "Atnaujinta grupė",
    "groupCategory": "Grupės kategorija",
    "category": "Kategorija",
    "addNewCategory": "PRIDĖTI NAUJĄ KATEGORIJĄ",
    "language": "Kalba",
    "groupLanguage": "Grupės kalba",
    "public": "Viešoji svetainė",
    "private": "Privatus",
    "groupName": "Grupės pavadinimas",
    "departmentName": "Skyriaus pavadinimas",
    "created_at": "Sukurta",
    "notFound": "Grupė nerasta",
    "notCreated": "Nesukurta",
    "noImage": "Nepridėtas vaizdas"
  },
  "learningObject": {
    "addLearningObject": "Įtraukti mokymosi objektą",
    "searchLearningObject": "Ieškoti mokymosi objektų",
    "name": "Vardas",
    "department": "Departamentas",
    "content": "Turinys",
    "isEnabled": "Įjungtas",
    "updatedLearningObject": "Atnaujintas mokymosi objektas",
    "createdNewLearningObject": "Sukurtas naujas mokymosi objektas",
    "author": "Autorius",
    "owner": "Savininkas",
    "editLearningObject": "Mokymosi objekto redagavimas",
    "deleteLearningObject": "Naikinti mokymosi objektą",
    "learningObjectDeleted": "Panaikintas mokymosi objektas"
  },
  "manual": {
    "userManuals": "Vartotojo vadovai",
    "userManual": "Vartotojo vadovas",
    "chooseOrWrite": "Pasirinkite esamą vartotojo vadovą arba parašykite naują.",
    "userManualName": "Vartotojo vadovo pavadinimas",
    "writeText": "Parašykite vartotojo vadovo tekstą",
    "input": "Įvestis",
    "saveUserManual": "Išsaugokite vartotojo vadovą",
    "addUserManual": "Pridėkite kitą vartotojo vadovą",
    "writeNew": "arba naudokite parašykite naują vartotojo vadovą",
    "searchExisting": "Ieškokite esamame vartotojo vadove..."
  },
  "patients": {
    "patientName": "Paciento vardas ir pavardė",
    "patientAssignedTo": "Pacientas, kuriam priskirtas",
    "datePatientAdded": "Paciento pridėjimo data",
    "status": "Statusas",
    "nextVisit": "Kitas apsilankymas",
    "addPatient": "Pridėti pacientą",
    "editPatient": "Redaguoti pacientą",
    "importPatients": "importuoti pacientus",
    "patientSearch": "Pacientų paieška",
    "scheduleVisit": "Planuoti vizitą",
    "primaryDiagnosis": "Pagrindinė diagnozė",
    "secondaryDiagnosis": "Antrinė diagnozė",
    "patientHistory": "Pacientų ligos istorija",
    "enterName": "Įveskite vardą ir pavardę",
    "birthDate": "Gimimo data",
    "visitAddress": "Apsilankymo adresas",
    "enterAddress": "Įveskite adresą",
    "email": "El. paštas",
    "enterPatientEmail": "Įveskite paciento el. pašto adresą",
    "phoneNumber": "Telefono numeris",
    "enterPatientNumber": "Įveskite paciento telefono numerį",
    "enterPrimaryDiagnosis": "Įveskite pagrindinę diagnozę",
    "enterSecondaryDiagnosis": "Įveskite antrinę diagnozę",
    "note": "Pastaba (neprivaloma)",
    "enterShortNote": "Įveskite trumpą pastabą",
    "assignedNurse": "Paskirtas slaugytojas",
    "fileRequirements": "Reikalavimai bylai",
    "firstRequirement": "Įkelkite XLS arba csv failą",
    "secondRequirement": "Mažiau nei 500 KB",
    "allergy": "Alergija",
    "allergies": "Alergijos",
    "allergyType": "Alergijos tipas (neprivaloma)",
    "medications": "Vaistai",
    "procedures": "Procedūros",
    "reaction": "Reakcija (neprivaloma)",
    "severity": "Sunkumas (neprivaloma)",
    "addAnotherAllergy": "Pridėti kitą alergiją",
    "medication": "Vaistai",
    "medicationType": "Vaistų tipas",
    "dosage": "Dozavimas",
    "frequency": "Dažnumas",
    "startDateOptional": "Pradžios data (neprivaloma)",
    "durationOptional": "Trukmė (neprivaloma)",
    "addAnotherMedication": "Pridėti kitą vaistą",
    "addAnotherProcedure": "Pridėti kitą procedūrą",
    "visit": "Apsilankymas",
    "visitStartTime": "Apsilankymo pradžios laikas",
    "visitEndTime": "Apsilankymo pabaigos laikas",
    "selectNurse": "Pasirinkite slaugytoją",
    "addAnotherVisit": "Pridėti kitą vizitą",
    "sex": "Lytis",
    "addNewAllergy": "Pridėti naują alergiją",
    "addNewMedication": "Įtraukti naujus vaistus",
    "addNewProcedure": "Pridėti naują procedūrą",
    "assignedProcedures": "Priskirtos procedūros",
    "scheduledProcedures": "Suplanuotos procedūros",
    "upcomingVisits": "Būsimi apsilankymai",
    "canceledVisits": "Atšaukti apsilankymai",
    "pastVisits": "Praėję apsilankymai",
    "department": "Skyrius",
    "departmentOptional": "Skyrius (neprivaloma)",
    "scheduledVisits": "Suplanuoti apsilankymai",
    "visitAssignedTo": "Apsilankymas priskirtas",
    "stable": "Stabilus",
    "improving": "Tobulinti",
    "deteriorating": "Blogėjantis",
    "notAssigned": "Nepriskirta",
    "ongoing": "Tęstinis",
    "pending": "Laukiama",
    "finished": "Baigtas"
  },
  "visitReport": {
    "consent": "Sutikimas",
    "viewConsent": "Peržiūrėti sutikimą",
    "homeVisit": "Apsilankymas namuose",
    "recomendationForTreatment": "Rekomendacijos dėl gydymo, priežiūros, darbo ir ambulatorinės priežiūros",
    "anamnesis": "Anamnezė",
    "answerType": "Atsakymo tipas",
    "contactPhone": "Kontaktinis telefonas",
    "contactEmail": "Kontaktinis el. paštas",
    "visitMadeBy": "Apsilankymas, kurį atliko",
    "homeVisitTime": "Apsilankymo namuose laikas",
    "visitForm": "Apsilankymo forma",
    "viewHistory": "Peržiūrėti istoriją",
    "patientsPrimaryHealthConcern": "Pacientų pagrindinė sveikatos problema",
    "conditionAssesmentInformation": "Informacija apie būklės vertinimą",
    "bloodPressure": "Kraujospūdis",
    "measurement": "Matavimas",
    "BMI": "KMI",
    "diagnosis": "Diagnozė",
    "appliedMedicalTreatments": "Taikomas medikamentinis gydymas",
    "appliedTreatment": "Taikomas gydymas",
    "descriptionOfTestsConsultationPlans": "Tyrimų ir (arba) konsultacijų planų aprašymas",
    "instrumentalTests": "Instrumentiniai tyrimai",
    "laboratoryTests": "Laboratoriniai tyrimai",
    "appliedMedicalTreatment": "Taikomasis medikamentinis gydymas",
    "specialist": "Specialistas",
    "status": "Būklė",
    "complaintData": "Skundų duomenys",
    "pulse": "Pulsas",
    "viewFullVisitForm": "Peržiūrėti visą apsilankymo formą",
    "height": "Aukštis",
    "weight": "Svoris"
  },
  "titles": {
    "home": "Pagrindinis",
    "institutions": "Institucijos",
    "departments": "Departamentai",
    "users": "Vartotojai",
    "nurselocation": "Slaugytojas Vieta",
    "procedures": "Procedūros",
    "study": "Tyrimas",
    "learningobjects": "Mokymosi objektai",
    "patients": "Pacientai",
    "visit forms": "Apsilankymo formos",
    "backToUsers": "Grįžti prie naudotojų",
    "backToVisits": "Grįžti prie vizitų",
    "backToPatientsList": "Atgal į pacientų sąrašą",
    "backToPatient": "Atgal į pacientą",
    "backToProcedures": "Atgal į procedūras",
    "backToProcedure": "Atgal į procedūrą",
    "backToStudyList": "Atgal į tyrimų sąrašą",
    "backToStatistics": "Atgal į statistiką",
    "backToStudy": "Atgal į tyrimą",
    "backToLearningObjects": "Atgal į mokymosi objektus",
    "study results": "Tyrimo rezultatai",
    "subscription": "Prenumerata",
    "scheduling": "Planavimas",
    "signup": "Registracija",
    "userresults": "Naudotojo rezultatai",
    "devices": "Prietaisai",
    "device": "Įrenginys",
    "groups": "Grupės",
    "group": "Grupė",
    "groupadd": "Pridėti grupę",
    "devicereports": "Įrenginio ataskaitos",
    "devicecharts": "Įrenginio diagramos",
    "approvalrequests": "Patvirtinimo prašymai"
  },
  "nurseRoute": {
    "viewRoute": "Rodyti maršrutą",
    "liveShift": "Pamainoje",
    "noActiveShift": "Nėra aktyvios pamainos",
    "shiftEnded": "Pamaina baigta — rodomas išsaugotas maršrutas",
    "lastUpdated": "Paskutinį kartą atnaujinta: {time}",
    "refreshHint": "gyvas maršrutas; sustojimai sinchronizuojami periodiškai",
    "historyFrom": "Maršruto istorija prieinama nuo {date}",
    "timeSpent": "Praleistas laikas",
    "minutes": "min",
    "loadFailed": "Nepavyko įkelti maršruto",
    "zoomToStop": "Priartinti prie sustojimo",
    "stopAddress": "Adresas",
    "stopArrival": "Atvykimas",
    "stopDeparture": "Išvykimas",
    "stopDuration": "Trukmė"
  },
  "approvalRequest": {
    "actionType": "Action Type",
    "requestedBy": "Requested By",
    "approvedBy": "Approved By",
    "confirms": {
      "approveTitle": "Approve request",
      "approveText": "Are you sure you want to approve this request?",
      "rejectTitle": "Reject request",
      "rejectText": "Please provide a reason for rejecting this request.",
      "rejectReasonPlaceholder": "Rejection reason"
    },
    "actionTypes": {
      "PERMISSION_GRANT": "Permission Grant",
      "PERMISSION_REVOKE": "Permission Revoke",
      "EXPORT_VISITS": "Export Visits",
      "EXPORT_LOCATION_HISTORY": "Export Location History",
      "EXPORT_ARRIVAL_HISTORY": "Export Arrival History",
      "ENABLE_USER": "Enable User",
      "DISABLE_USER": "Disable User"
    },
    "toasts": {
      "created": "Approval request created",
      "applied": "Action applied",
      "applyFailed": "Failed to apply action",
      "approved": "Request approved",
      "approveFailed": "Failed to approve request",
      "rejected": "Request rejected",
      "rejectFailed": "Failed to reject request"
    }
  }
}
